class ErrorWithCause extends Error {
    isNetworkError;
    cause;
    constructor(message, options) {
        super(message);
        this.cause = options?.cause;
        if (this.cause && Object.hasOwn(this.cause, 'isNetworkError')) {
            this.isNetworkError = this.cause.isNetworkError;
        }
        else {
            this.isNetworkError = false;
        }
    }
}
export default ErrorWithCause;
